import { render, staticRenderFns } from "./card-widget.vue?vue&type=template&id=211e714c&scoped=true"
import script from "./card-widget.vue?vue&type=script&lang=js"
export * from "./card-widget.vue?vue&type=script&lang=js"
import style0 from "./card-widget.vue?vue&type=style&index=0&id=211e714c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "211e714c",
  null
  
)

export default component.exports